/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentData, ComponentModel, ComponentFieldKey } from '../model/component.model';
import { ObservableMap, ObserveModes } from '@typescript-kit/core';
import { Orientation, Orientations } from '../model/orientation.model';
import { Alignment, Alignments } from '../model/alignment.model';
import { ViewComponentKey } from '../key/view-component.key';

export interface ContainerData extends ComponentData {
  items?: Iterable<ComponentData>;
  orientation?: Orientation;
  alignment?: Alignment;
}

export class ContainerFieldKey {
  static readonly ITEMS = 'items';
  static readonly ORIENTATION = 'orientation';
  static readonly ALIGNMENT = 'alignment';
}

export class ContainerModel extends ComponentModel implements ContainerData {
  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(ContainerFieldKey).map((key) => ContainerFieldKey[key])
  );

  constructor(data?: ContainerData, keys?: string[]) {
    super(data, keys || ContainerModel.KEYS, { observeMode: ObserveModes.FLAT });
  }

  get children(): Iterable<ComponentModel> {
    return this.items;
  }

  get items(): ObservableMap<ComponentModel> {
    return this.get(ContainerFieldKey.ITEMS);
  }

  set items(value: ObservableMap<ComponentModel>) {
    this.set(ContainerFieldKey.ITEMS, value);
  }

  get orientation(): Orientation {
    return this.get(ContainerFieldKey.ORIENTATION);
  }

  set orientation(value: Orientation) {
    this.set(ContainerFieldKey.ORIENTATION, value);
  }

  get alignment(): Alignment {
    return this.get(ContainerFieldKey.ALIGNMENT);
  }

  set alignment(value: Alignment) {
    this.set(ContainerFieldKey.ALIGNMENT, value);
  }

  protected setupValues(values: ContainerData, exclusive: boolean): ContainerData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.CONTAINER;
    }
    if (exclusive && !(ContainerFieldKey.ORIENTATION in values)) {
      values.orientation = Orientations.STACKED;
    }
    if (exclusive && !(ContainerFieldKey.ALIGNMENT in values)) {
      values.alignment = Alignments.STRETCH;
    }
    this.setupChildren(ContainerFieldKey.ITEMS, values, exclusive);
    return super.setupValues(values, exclusive) as ContainerData;
  }

}
